const rankingItems = [
  { rank: 1, title: '庆余年2', type: '国产剧', hot: '986万热度', trend: 'up' },
  { rank: 2, title: '流浪地球3', type: '电影', hot: '872万热度', trend: 'up' },
  { rank: 3, title: '与凤行', type: '国产剧', hot: '765万热度', trend: 'up' },
  { rank: 4, title: '狂飙', type: '刑侦剧', hot: '698万热度', trend: 'same' },
  { rank: 5, title: '繁花', type: '国产剧', hot: '621万热度', trend: 'down' },
  { rank: 6, title: '漫长的季节', type: '悬疑剧', hot: '554万热度', trend: 'up' },
  { rank: 7, title: '三体', type: '科幻剧', hot: '487万热度', trend: 'same' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">热度榜单</h2>
          <p className="text-sm md:text-base text-foreground-600">实时热度排行，看看大家都在追什么。</p>
        </div>

        <div className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
          <div className="grid grid-cols-12 gap-3 px-5 py-3 bg-background-200/50 border-b border-background-200/70 text-xs text-foreground-500 font-medium">
            <span className="col-span-2">排名</span>
            <span className="col-span-4">影片</span>
            <span className="col-span-3">类型</span>
            <span className="col-span-3 text-right">热度</span>
          </div>
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="grid grid-cols-12 gap-3 px-5 py-4 border-b border-background-200/50 last:border-b-0 hover:bg-background-50 transition-colors cursor-pointer items-center"
            >
              <span className="col-span-2">
                <span
                  className={`inline-flex items-center justify-center w-7 h-7 rounded-lg text-xs font-bold ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-200 text-foreground-600'
                  }`}
                >
                  {item.rank}
                </span>
              </span>
              <span className="col-span-4 text-sm font-medium text-foreground-900 truncate">{item.title}</span>
              <span className="col-span-3 text-xs text-foreground-500">{item.type}</span>
              <span className="col-span-3 text-right text-xs text-foreground-600 flex items-center justify-end gap-1">
                {item.trend === 'up' && <i className="ri-arrow-up-line text-green-500 text-xs"></i>}
                {item.trend === 'down' && <i className="ri-arrow-down-line text-red-400 text-xs"></i>}
                {item.trend === 'same' && <i className="ri-subtract-line text-foreground-400 text-xs"></i>}
                {item.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}